import styles from "./StatisticsFuturePanel.module.scss";

export function StatisticsFuturePanel() {
  return (
    <div className={styles["comp"]}>
      <p className={styles["comp__text"]}>
        Additional analytics will appear here in a future update.
      </p>
    </div>
  );
}
